import { useEffect, useMemo, useState } from "react";
import { Select } from "antd";
import { getBusinessAccount } from "../service/api";
import { useQuery } from "react-query";

const BusinessSelect = ({ merchantId, token, setSelectedBusiness }) => {
  const [value, setValue] = useState(null);
  const { data, isLoading, error } = useQuery({
    queryKey: ["businessAccounts", merchantId, token],
    queryFn: getBusinessAccount,
  });

  const businessAccounts = useMemo(() => {
    if (!data || data.length === 0) return [];
    return data.map((account, index) => ({
      value: account.id,
      label: account.businessName,
      apiKey: account.apiKey,
      apiToken: account.apiToken,
    }));
  }, [data]);

  useEffect(() => {
    if (businessAccounts.length > 0) {
      const first = businessAccounts[0];
      setValue(first.value);

      setSelectedBusiness({
        id: first.value,
        apiKey: first.apiKey,
        apiToken: first.apiToken,
      });
    }
  }, [businessAccounts]);

  return (
    <Select
      value={value}
      loading={isLoading}
      error={error}
      showSearch
      style={{ width: 300 }}
      placeholder="Choisir un busisness"
      optionFilterProp="label"
      filterSort={(optionA, optionB) =>
        (optionA?.label ?? "")
          .toLowerCase()
          .localeCompare((optionB?.label ?? "").toLowerCase())
      }
      options={businessAccounts}
      onChange={(value, option) => {
        setValue(value);

        setSelectedBusiness({
          id: value,
          apiKey: option.apiKey,
          apiToken: option.apiToken,
        });
      }}
    />
  );
};
export default BusinessSelect;
